import Vue from 'vue'
import VueRouter from 'vue-router'
// import { createRouter, createWebHistory,VueRouter } from "vue-router";
Vue.use(VueRouter)
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/loginPage.vue')
  },
  {
    path: '/loginG5',
    name: 'loginG5',
    component: () => import('@/views/loginPageG5.vue')
  },
  {
    path: '/LargeDataScreen/EnergyUseDataShow',
    name: '工厂用能大屏-展厅',
    component: () =>
      import('@/views/LargeDataScreen/EnergyUseDataShow/index.vue'),
  },
  {
    path: '/LargeDataScreen/IncomeEnergyLeiLiShow',
    name: '雷利收益大屏-展厅',
    component: () => import('@/views/LargeDataScreen/IncomeEnergyLeiLiShow/index.vue'),
  },
  {
    path: '/',
    name: 'layout',
    component: () => import('@/layout/index.vue'),
    children: [
      {
        path: 'LargeDataScreen/EnergyUseDataNew',
        name: '工厂用能大屏',
        component: () =>
          import('@/views/LargeDataScreen/EnergyUseDataNew/index.vue'),
        meta: {
          title: '工厂用能大屏',
          requiredPermissions: ['energy_data_large_screen_menu'],
          showInSidebar: false
        }
      },
      // 数据大屏 stare-----------
      {
        path: 'LargeDataScreen/IncomeEnergyLeiLi',
        name: '雷利收益大屏',
        component: () => import('@/views/LargeDataScreen/IncomeEnergyLeiLi/index.vue'),
        meta: {
          title: '雷利收益大屏',
          requiredPermissions: ['leili_earn_data_large_screen_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'LargeDataScreen/IncomeData',
        name: '区域收益大屏',
        component: () => import('@/views/LargeDataScreen/IncomeData/index.vue'),
        meta: {
          title: '区域收益大屏',
          requiredPermissions: ['earn_data_large_screen_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'LargeDataScreen/carbonEmission',
        name: '碳排放看板',
        component: () => import('@/views/LargeDataScreen/carbonEmission/index.vue'),
        meta: {
          title: '碳排放看板',
          requiredPermissions: ['carbon_emission_dashboard_menu'],
          showInSidebar: false
        }
      },
      
 
      // {
      //   path: 'LargeDataScreen/EnergyUseData',
      //   name: '用能数据大屏',
      //   component: () =>
      //     import('@/views/LargeDataScreen/EnergyUseData/index.vue'),
      //   meta: {
      //     title: '用能数据大屏',
      //     requiredPermissions: ['energy_data_large_screen_menu'],
      //     showInSidebar: false
      //   }
      // },
      
      // 数据大屏 end-----------

      {
        path: 'RealTimeMonitoring',
        name: '实时监测',
        component: () => import('@/views/RealTimeMonitoring/index.vue'),
        meta: {
          title: '实时监测',
          requiredPermissions: ['real_time_monitor_menu'],
          showInSidebar: false
        }
      },
      // 总览 end-----------

      // 报表中心 stare-----------
      {
        path: 'ReportAnalysis/EnergyTrend',
        name: '能耗趋势',
        component: () =>
          import('@/views/ReportAnalysis/EnergyTrend/index.vue'),
        meta: {
          title: '能耗趋势',
          requiredPermissions: ['energy_trend_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportAnalysis/compareEnergy',
        name: '工况对比',
        component: () =>
          import('@/views/ReportAnalysis/compareEnergy/index.vue'),
        meta: {
          title: '工况对比',
          requiredPermissions: ['energy_compare_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportAnalysis/compareAnalysis',
        name: '对比分析',
        component: () =>
          import('@/views/ReportAnalysis/compareAnalysis/index.vue'),
        meta: {
          title: '对比分析',
          requiredPermissions: ['compare_analysis_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportCenter/incomeStatement',
        name: '用能报表',
        component: () =>
          import('@/views/ReportCenter/incomeStatement/index.vue'),
        meta: {
          title: '用能报表',
          requiredPermissions: ['earn_report_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportCenter/profitStatement',
        name: '收益报表',
        component: () =>
          import('@/views/ReportCenter/profitStatement/index.vue'),
        meta: {
          title: '收益报表',
          requiredPermissions: ['org_earn_report_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportCenter/collectionReport',
        name: '回款报表',
        component: () =>
          import('@/views/ReportCenter/collectionReport/index.vue'),
        meta: {
          title: '回款报表',
          requiredPermissions: ['earn_receive_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportCenter/revenueRanking',
        name: '客户排名',
        component: () =>
          import('@/views/ReportCenter/revenueRanking/index.vue'),
        meta: {
          title: '客户排名',
          requiredPermissions: ['earn_rank_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'alarmManagement/alarmMessage',
        name: '告警信息',
        component: () =>
          import('@/views/alarmManagement/alarmMessage/index.vue'),
        meta: {
          title: '告警信息',
          requiredPermissions: ['alarm_info_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'alarmManagement/alarmRule',
        name: '告警规则',
        component: () =>
          import('@/views/alarmManagement/alarmRule/index.vue'),
        meta: {
          title: '告警规则',
          requiredPermissions: ['alarm_config_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportCenter/SettlementStatement',
        name: '客户结算汇总',
        component: () =>
          import('@/views/ReportCenter/SettlementStatement/index.vue'),
        meta: {
          title: '客户结算汇总',
          requiredPermissions: ['settle_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportAnalysis/EnergySavingDetails',
        name: '电机日收益明细',
        component: () =>
          import('@/views/ReportAnalysis/EnergySavingDetails/index.vue'),
        meta: {
          title: '电机日收益明细',
          requiredPermissions: ['earn_detail_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportAnalysis/EnergyUseingDetails',
        name: '客户电机日用能',
        component: () =>
          import('@/views/ReportAnalysis/EnergyUseingDetails/index.vue'),
        meta: {
          title: '客户电机日用能',
          requiredPermissions: ['energy_detail_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'ReportAnalysis/RealTimeDetails',
        name: '电机原始数据',
        component: () =>
          import('@/views/ReportAnalysis/RealTimeDetails/index.vue'),
        meta: {
          title: '电机原始数据',
          requiredPermissions: ['device_real_data_menu'],
          showInSidebar: false
        }
      },

      // 报表中心 end-----------
      // 电机资产 stare-----------
      {
        path: 'MotorAssets/MotorAssets',
        name: '电机资产',
        component: () => import('@/views/MotorAssets/MotorAssets/index.vue'),
        meta: {
          title: '电机资产',
          requiredPermissions: ['device_asset_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'MotorAssets/CustomerProfile',
        name: '客户档案',
        component: () =>
          import('@/views/MotorAssets/CustomerProfile/index.vue'),
        meta: {
          title: '客户档案',
          requiredPermissions: ['customer_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'MotorAssets/ElectricityPriceAllocation',
        name: '电价配置',
        component: () =>
          import('@/views/MotorAssets/ElectricityPriceAllocation/index.vue'),
        // import("@/views/basicSettings/electricityPrice.vue"),
        meta: {
          title: '电价配置',
          requiredPermissions: ['priceSetting_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'MotorAssets/AllocationSharingRules',
        name: '分成规则配置',
        component: () =>
          import('@/views/MotorAssets/AllocationSharingRules/index.vue'),
        meta: {
          title: '分成规则配置',
          requiredPermissions: ['earn_rule_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'MotorAssets/ItemList',
        name: '项目清单',
        component: () => import('@/views/MotorAssets/ItemList/index.vue'),
        meta: {
          title: '项目清单',
          requiredPermissions: ['project_menu'],
          showInSidebar: false
        }
      },
      {
        path: '/EnergyCarbon/CarbonSo',
        name: '碳排放因子',
        component: () => import('@/views/EnergyCarbon/CarbonSo/index.vue'),
        meta: {
          title: '碳排放因子',
          requiredPermissions: ['carbon_emission_ratio_config_menu'],
          showInSidebar: false
        }
      },
      // 电机资产 end-----------
      // 基础设置 stare-----------
      // {
      //   path: "basic/LabelConfiguration",
      //   name: "标签配置",
      //   component: () =>
      //     import("@/views/basicSettings/LabelConfiguration/index.vue"),
      //   meta: {
      //     title: "标签配置",
      //     requiredPermissions: ["label_menu"],
      //     showInSidebar: false,
      //   },
      // },
      {
        path: 'basic/motor',
        name: '型号档案',
        component: () => import('@/views/basicSettings/motorFile.vue'),
        meta: {
          title: '型号档案',
          requiredPermissions: ['motor_type_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'MotorAssets/baseEnergySet',
        name: '基准能耗配置',
        component: () => import('@/views/MotorAssets/baseEnergySet/index.vue'),
        meta: {
          title: '基准能耗配置',
          requiredPermissions: ['base_energy_config_menu'],
          showInSidebar: false
        }
      },
      // 平台管理 stare-----------
      {
        path: 'platform/organization',
        name: '组织管理',
        component: () => import('@/views/platform/organizationPage.vue'),
        meta: {
          title: '组织管理',
          requiredPermissions: ['org_manage_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'platform/UserManagement',
        name: '用户管理',
        component: () => import('@/views/platform/UserManagement/index.vue'),
        meta: {
          title: '用户管理',
          requiredPermissions: ['user_manage_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'platform/RoleManagement',
        name: '角色管理',
        component: () => import('@/views/platform/RoleManagement/index.vue'),
        meta: {
          title: '角色管理',
          requiredPermissions: ['user_role_manage_menu'],
          showInSidebar: false
        }
      },

      // 平台管理 end-----------

      {
        path: 'Energyoverview/Energyoverview',
        name: '用能概况(待开发)',
        component: () =>
          import('@/views/EnergyAnalysis/Energyoverview/index.vue'),
        meta: {
          title: '用能概况(待开发)',
          requiredPermissions: ['energy_overview_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'Energyoverview/EnergySavingReport',
        name: '节能报表(待开发)',
        component: () =>
          import('@/views/EnergyAnalysis/EnergySavingReport/index.vue'),
        meta: {
          title: '节能报表(待开发)',
          requiredPermissions: ['energy_report_menu'],
          showInSidebar: false
        }
      },
      {
        path: 'Energyoverview/EnergySavingComparison',
        name: '节能对比(待开发)',
        component: () =>
          import('@/views/EnergyAnalysis/EnergySavingComparison/index.vue'),
        meta: {
          title: '节能对比(待开发)',
          requiredPermissions: ['energy_compare_menu'],
          showInSidebar: false
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
